import styles from "../../styles/app.module.scss";

function Unauthorized() {
    return (
        <div className={styles.app}>You don't have access to this page.</div>
    )
}

export default Unauthorized;